var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "box-processo", attrs: { shadow: "hover" } },
    [
      _c("h1", [_vm._v("Gerenciar Chaves de Segurança")]),
      _c(
        "div",
        { staticClass: "containerForm" },
        [
          _c(
            "el-form",
            {
              ref: "formChave",
              attrs: {
                model: _vm.chave,
                rules: _vm.rules,
                "label-position": "top"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Nome", prop: "nome" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Digite o nome da chave" },
                    model: {
                      value: _vm.chave.nome,
                      callback: function($$v) {
                        _vm.$set(_vm.chave, "nome", $$v)
                      },
                      expression: "chave.nome"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Chave de segurança", prop: "chave" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Digite a chave" },
                    model: {
                      value: _vm.chave.chave,
                      callback: function($$v) {
                        _vm.$set(_vm.chave, "chave", $$v)
                      },
                      expression: "chave.chave"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Tipo", prop: "tipo" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Selecione o tipo" },
                      model: {
                        value: _vm.chave.tipo,
                        callback: function($$v) {
                          _vm.$set(_vm.chave, "tipo", $$v)
                        },
                        expression: "chave.tipo"
                      }
                    },
                    _vm._l(_vm.tiposChave, function(tipo) {
                      return _c("el-option", {
                        key: tipo,
                        attrs: { label: tipo, value: tipo }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Usuário", prop: "idUsuario" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Selecione o usuário" },
                      model: {
                        value: _vm.chave.idUsuario,
                        callback: function($$v) {
                          _vm.$set(_vm.chave, "idUsuario", $$v)
                        },
                        expression: "chave.idUsuario"
                      }
                    },
                    _vm._l(_vm.usuarios, function(usuario) {
                      return _c("el-option", {
                        key: usuario.id,
                        attrs: { label: usuario.nome, value: usuario.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveChave }
                    },
                    [_vm._v("Salvar")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.gerarChave }
                    },
                    [_vm._v("Gerar Chave")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "containerTodo" }, [
        _c(
          "div",
          { staticClass: "containerCabecalho" },
          [
            _c("el-input", {
              attrs: { placeholder: "Buscar chave por nome" },
              on: { input: _vm.filtrarChaves },
              model: {
                value: _vm.filtroNome,
                callback: function($$v) {
                  _vm.filtroNome = $$v
                },
                expression: "filtroNome"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "tabelaContainer" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.chavesFiltradas, border: "border" }
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "nome", label: "Nome" }
                }),
                _c("el-table-column", {
                  attrs: { prop: "tipo", label: "Tipo" }
                }),
                _c("el-table-column", {
                  attrs: { prop: "chave", label: "Chave" }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "data",
                    label: "Criado em",
                    formatter: _vm.formatarData
                  }
                }),
                _c("el-table-column", {
                  attrs: { prop: "ativa", label: "Status" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          row.ativa
                            ? _c("span", { staticClass: "ativa" }, [
                                _vm._v("Ativa")
                              ])
                            : _c("span", { staticClass: "inativa" }, [
                                _vm._v("Inativa")
                              ])
                        ]
                      }
                    }
                  ])
                }),
                _c("el-table-column", {
                  attrs: { label: "Ações", width: "250" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          !row.ativa
                            ? _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "success" },
                                  on: {
                                    click: function($event) {
                                      return _vm.alterarStatus(row.id, true)
                                    }
                                  }
                                },
                                [_vm._v("Ativar")]
                              )
                            : _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "danger" },
                                  on: {
                                    click: function($event) {
                                      return _vm.alterarStatus(row.id, false)
                                    }
                                  }
                                },
                                [_vm._v("Desativar")]
                              ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                type: "info",
                                icon: "el-icon-view"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.abrirModalLogs(row.id)
                                }
                              }
                            },
                            [_vm._v("Ver Logs")]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Logs da Chave",
            visible: _vm.modalLogsVisivel,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.modalLogsVisivel = $event
            }
          }
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.logs, border: "border" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "data",
                  label: "Data",
                  formatter: _vm.formatarData
                }
              }),
              _c("el-table-column", { attrs: { prop: "ip", label: "ip" } }),
              _c("el-table-column", {
                attrs: { prop: "tipo", label: "Tipo Acesso" }
              })
            ],
            1
          ),
          _vm.totalLogs > 0
            ? _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageable.page,
                  "page-size": _vm.pageable.size,
                  total: _vm.totalLogs,
                  layout: "prev, pager, next"
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.onPageChange
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0a3a93e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0a3a93e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/ChaveSeguranca.vue
// module id = null
// module chunks = 